module.exports = __webpack_public_path__ + "media/images/wedding/20-06c20a8721f28fbbba1c0a75925afae7.jpg";